/* Card photo swipe: every product card with data-vc-swipe gets a strip of its colour's photos.
   Phones swipe it, computers use the arrows or a trackpad. The card's own photo stays the first slide,
   so colour swatches, Variantify and the hover photo keep working on it. */
(function () {
  if (window.vcCardSwipe) return;
  window.vcCardSwipe = true;

  var MAX = 8;
  var WIDTHS = [375, 750, 1000, 1440];
  var states = new WeakMap();
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var coarse = window.matchMedia('(pointer: coarse)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CHEVRON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg>';

  function stem(url) {
    if (!url) return '';
    var name = url.split('?')[0].split('/').pop() || '';
    return name.replace(/\.(jpe?g|png|webp|gif|avif)$/i, '').replace(/_(\d+x\d*|x\d+)$/i, '').toLowerCase();
  }

  /* One entry per hashtag; #Black|White gives ['black', 'white'] */
  function groupsOf(alt) {
    return ((alt || '').match(/#[^\s#]+/g) || []).map(function (t) {
      return t.slice(1).toLowerCase().split('|').filter(Boolean);
    });
  }

  function tagsOf(alt) {
    return [].concat.apply([], groupsOf(alt));
  }

  function srcOf(img) {
    var src = img.getAttribute('src');
    if (src) return src;
    return (img.getAttribute('srcset') || '').trim().split(/\s+/)[0] || '';
  }

  function mainImg(box) {
    return box.querySelector('img:not(.card__img--hover):not(.vcvt-card__img2):not(.vc-sw-img)');
  }

  function hoverImg(box) {
    return box.querySelector('.card__img--hover, .vcvt-card__img2');
  }

  /* "a.jpg #Black b.jpg #Black|White #Mini c.jpg" -> [['a.jpg', '#Black'], ['b.jpg', '#Black|White #Mini'], ['c.jpg', '']] */
  function parse(s) {
    var list = [];
    (s || '').split(/\s+/).forEach(function (t) {
      if (!t) return;
      if (t.charAt(0) !== '#') list.push([t, '']);
      else if (list.length) list[list.length - 1][1] += ' ' + t;
    });
    return list;
  }

  function sized(file, w) {
    var url = (file.indexOf('/') > -1 ? '/cdn/shop/' : '/cdn/shop/files/') + file;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Close to the product page gallery: a photo joins when each of its tags is one of the shown photo's tags,
     or the other way round (#Mink takes #Mink #Mini; #DustyRose #Standard leaves out #Black #Standard).
     Untagged and #all photos follow. A shown photo with no tag gets every photo. One missing from the data
     (colour tab cards show a variant's own file) uses the card's data-vc-swipe-tag colour, or gets no strip. */
  function pick(list, shown, skip, hint) {
    var s = stem(shown);
    var own = null;
    list.forEach(function (m) { if (stem(m[0]) === s) own = tagsOf(m[1]); });
    if (!own && hint) own = [hint];
    if (!own) return [];
    var tagged = [];
    var untagged = [];
    list.forEach(function (m) {
      var ms = stem(m[0]);
      if (ms === s || (skip && ms === skip)) return;
      var g = groupsOf(m[1]);
      if (!own.length) tagged.push(m);
      else if (!g.length || g.some(function (x) { return x.indexOf('all') > -1; })) untagged.push(m);
      else if (g.every(function (x) { return x.some(function (y) { return own.indexOf(y) > -1; }); }) ||
        own.every(function (y) { return g.some(function (x) { return x.indexOf(y) > -1; }); })) tagged.push(m);
    });
    return tagged.concat(untagged).slice(0, MAX - 1);
  }

  function clear(st) {
    ['track', 'dots', 'prev', 'next'].forEach(function (k) {
      if (st[k]) st[k].remove();
      st[k] = null;
    });
    st.box.classList.remove('vc-sw-on');
  }

  function load(st, i) {
    [i, i + 1].forEach(function (n) {
      var slide = st.track && st.track.children[n];
      var img = slide && slide.querySelector('img[data-src]');
      if (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      }
    });
  }

  /* quiet: set the dots only; extra photos wait for a touch, hover, arrow or scroll */
  function update(st, quiet) {
    var w = st.track.clientWidth || 1;
    var i = Math.round(st.track.scrollLeft / w);
    var last = st.track.children.length - 1;
    i = Math.max(0, Math.min(last, i));
    st.index = i;
    if (!quiet) load(st, i);
    Array.prototype.forEach.call(st.dots.children, function (d, n) { d.classList.toggle('is-on', n === i); });
    if (st.prev) st.prev.classList.toggle('is-off', i === 0);
    if (st.next) st.next.classList.toggle('is-off', i === last);
  }

  function go(st, step, e) {
    e.preventDefault();
    e.stopPropagation();
    load(st, st.index + step);
    st.track.scrollTo({ left: (st.index + step) * st.track.clientWidth, behavior: still.matches ? 'auto' : 'smooth' });
  }

  function render(st) {
    var shown = srcOf(st.img);
    var s = stem(shown);
    if (st.track && st.shown === s) return;
    st.shown = s;
    /* A colour change keeps the shopper on the same photo number (the last one if the new colour has fewer) */
    var keep = st.track ? Math.round(st.track.scrollLeft / (st.track.clientWidth || 1)) : 0;
    clear(st);

    var hov = hoverImg(st.box);
    var skip = canHover.matches && hov ? stem(srcOf(hov)) : '';
    var others = pick(st.list, shown, skip, st.hint);
    if (!others.length) return;

    var dpr = window.devicePixelRatio || 1;
    var need = (st.box.clientWidth || 300) * dpr;
    var w = WIDTHS.filter(function (x) { return x >= need; })[0] || WIDTHS[WIDTHS.length - 1];
    var cs = getComputedStyle(st.img);

    var track = document.createElement('div');
    track.className = 'vc-sw-track' + (coarse.matches ? ' swiper-no-swiping' : '');
    track.tabIndex = -1;
    track.setAttribute('aria-hidden', 'true');
    track.style.setProperty('--vc-sw-fit', cs.objectFit || 'cover');
    track.style.setProperty('--vc-sw-pos', cs.objectPosition || 'center');
    track.appendChild(document.createElement('div')).className = 'vc-sw-slide';
    others.forEach(function (m) {
      var slide = document.createElement('div');
      slide.className = 'vc-sw-slide';
      var img = document.createElement('img');
      img.className = 'vc-sw-img';
      img.alt = '';
      img.draggable = false;
      img.decoding = 'async';
      img.setAttribute('data-src', sized(m[0], w));
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'vc-sw-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var n = 0; n <= others.length; n++) dots.appendChild(document.createElement('span'));

    (hov && hov.parentNode === st.img.parentNode ? hov : st.img).after(track, dots);
    /* Colour-tab photo links clip their children, so the line moves under the photo, into the card top */
    if (st.box.classList.contains('vcvt-card__media')) st.box.after(dots);
    st.track = track;
    st.dots = dots;

    if (canHover.matches) {
      st.prev = document.createElement('span');
      st.prev.className = 'vc-sw-arrow vc-sw-arrow--prev';
      st.next = document.createElement('span');
      st.next.className = 'vc-sw-arrow vc-sw-arrow--next';
      [st.prev, st.next].forEach(function (a) {
        a.setAttribute('aria-hidden', 'true');
        a.innerHTML = CHEVRON;
      });
      st.prev.addEventListener('click', function (e) { go(st, -1, e); });
      st.next.addEventListener('click', function (e) { go(st, 1, e); });
      track.after(st.prev, st.next);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; if (st.track === track) update(st); });
    }, { passive: true });

    /* Parent sliders (home tabs, recommendations) would take the swipe; touch only, so mouse drag still moves them */
    var stopTouch = function (e) {
      if (e.type === 'touchstart' || e.pointerType === 'touch') {
        e.stopPropagation();
        load(st, st.index);
      }
    };
    track.addEventListener('pointerdown', stopTouch);
    track.addEventListener('touchstart', stopTouch, { passive: true });

    st.index = 0;
    st.box.classList.add('vc-sw-on');
    keep = Math.min(Math.max(0, keep), others.length);
    if (keep) {
      load(st, keep);
      track.scrollLeft = keep * track.clientWidth;
    }
    update(st, true);
  }

  /* Cards in a sideways row (home Bestsellers on phones, product sliders) keep one photo: a strip there takes the swipe that should move the row */
  function inRow(box) {
    for (var el = box.parentElement; el && el !== document.body; el = el.parentElement) {
      /* Theme sliders carry .wt-slider from the first paint; .swiper only once Swiper starts */
      if (el.classList.contains('swiper') || el.classList.contains('wt-slider')) return true;
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1) return true;
    }
    return false;
  }

  function build(box) {
    if (states.has(box) || inRow(box)) return;
    /* A card copied by Variantify or a section reload carries a dead strip: remove it and build again */
    box.querySelectorAll('.vc-sw-track, .vc-sw-dots, .vc-sw-arrow').forEach(function (n) { n.remove(); });
    if (box.parentElement) box.parentElement.querySelectorAll(':scope > .vc-sw-dots').forEach(function (n) { n.remove(); });
    box.classList.remove('vc-sw-on');
    var list = parse(box.getAttribute('data-vc-swipe'));
    var img = mainImg(box);
    if (!img || list.length < 2 || box.querySelector('video')) return;
    var st = { box: box, img: img, list: list, index: 0, hint: box.getAttribute('data-vc-swipe-tag') };
    states.set(box, st);
    render(st);
    box.addEventListener('pointerenter', function () { if (st.track) load(st, st.index); });
    new MutationObserver(function () { render(st); }).observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        io.unobserve(en.target);
        build(en.target);
      }
    });
  }, { rootMargin: '200px' }) : null;

  function watch(root) {
    if (root.nodeType !== 1) return;
    var boxes = root.matches('[data-vc-swipe]') ? [root] : [];
    root.querySelectorAll('[data-vc-swipe]').forEach(function (b) { boxes.push(b); });
    boxes.forEach(function (b) {
      if (states.has(b)) return;
      if (io) io.observe(b); else build(b);
    });
  }

  function start() {
    watch(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(watch); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
